import React from "react";
import { Box, Container } from "@mui/material";

const BLOCK = "#eeeee9";
const BLOCK_SOFT = "#f4f4f1";

function Block({ sx }) {
  return (
    <Box
      sx={{
        bgcolor: BLOCK,
        borderRadius: 0,
        ...sx,
      }}
    />
  );
}

function TitleLine() {
  return (
    <Block
      sx={{
        width: { xs: 120, md: 150 },
        height: 10,
        mx: "auto",
        mb: { xs: 4, md: 5 },
        bgcolor: BLOCK_SOFT,
      }}
    />
  );
}

function SliderSkeleton() {
  return (
    <Box sx={{ bgcolor: "#fff", py: { xs: 8, md: 10 }, px: { xs: 2, md: 3 } }}>
      <Container maxWidth="xl" disableGutters>
        <TitleLine />
        <Box
          sx={{
            display: "flex",
            gap: { xs: 1.5, md: 2 },
            overflow: "hidden",
          }}
        >
          {[0, 1, 2].map((index) => (
            <Box
              key={index}
              sx={{
                flex: {
                  xs: "0 0 72%",
                  sm: "0 0 48%",
                  md: "0 0 32%",
                },
              }}
            >
              <Box sx={{ aspectRatio: "4 / 5", bgcolor: BLOCK }} />
              <Block
                sx={{
                  width: "55%",
                  height: 8,
                  mt: 2,
                  mx: "auto",
                  bgcolor: BLOCK_SOFT,
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

function ProductsSkeleton() {
  return (
    <Box sx={{ bgcolor: "#fff", py: { xs: 8, md: 10 }, px: { xs: 2, md: 3 } }}>
      <Container maxWidth="xl" disableGutters>
        <TitleLine />
        <Box
          sx={{
            display: "flex",
            gap: { xs: 1.5, md: 2 },
            overflow: "hidden",
          }}
        >
          {[0, 1, 2, 3, 4].map((index) => (
            <Box
              key={index}
              sx={{
                flex: {
                  xs: "0 0 42%",
                  sm: "0 0 28%",
                  md: "0 0 18%",
                },
              }}
            >
              <Box sx={{ aspectRatio: "1 / 1", bgcolor: BLOCK }} />
              <Block
                sx={{ width: "70%", height: 7, mt: 1.5, bgcolor: BLOCK_SOFT }}
              />
              <Block
                sx={{ width: "45%", height: 7, mt: 1, bgcolor: BLOCK_SOFT }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

function BannerSkeleton() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100svh",
        bgcolor: BLOCK_SOFT,
      }}
    />
  );
}

function GridSkeleton() {
  return (
    <Box sx={{ bgcolor: "#fff", py: { xs: 8, md: 10 }, px: { xs: 2, md: 3 } }}>
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: { xs: 6, md: 4 },
          }}
        >
          {[0, 1].map((index) => (
            <Box key={index}>
              <Box sx={{ aspectRatio: "16 / 9", bgcolor: BLOCK }} />
              <Block
                sx={{
                  width: index === 0 ? "55%" : "50%",
                  height: 10,
                  mt: 2.5,
                  bgcolor: BLOCK_SOFT,
                }}
              />
              <Block
                sx={{ width: "80%", height: 8, mt: 1.5, bgcolor: BLOCK_SOFT }}
              />
              <Block
                sx={{ width: 90, height: 32, mt: 2.5, bgcolor: BLOCK }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

const VARIANTS = {
  slider: SliderSkeleton,
  products: ProductsSkeleton,
  banner: BannerSkeleton,
  grid: GridSkeleton,
};

export function HomeSectionSkeleton({ variant = "slider" }) {
  const Component = VARIANTS[variant] || SliderSkeleton;
  return <Component />;
}

export function HeroPlaceholder({ theme }) {
  return (
    <Box
      sx={{
        width: "100%",
        height: {
          xs: `calc(100svh - ${theme.appbar_height.mobile})`,
          md: `calc(100svh - ${theme.appbar_height.desktop})`,
        },
        bgcolor: "#0a0a0a",
      }}
    />
  );
}
